import { createContext } from 'react'
import {
  DEFAULT_ADDRESS,
  DEFAULT_LAT,
  DEFAULT_LON,
  DEFAULT_RADIUS_IN_METERS
} from '@/modules/accredited-establishments/constants'
import { FiltersState } from '@/modules/accredited-establishments/hooks/useFiltersReducer/useFiltersReducer.types'

const defaultFilters: FiltersState = {
  view: 'list',
  filterPresentation: 'expanded',
  providerSearchOpen: false,
  categories: [],
  ready: false,
  providerName: undefined,
  plan: undefined,
  specialty: undefined,
  gender: undefined,
  appointmentType: undefined,
  markerLocation: {
    type: 'coordinates',
    lat: DEFAULT_LAT,
    lon: DEFAULT_LON,
    radiusInMeters: DEFAULT_RADIUS_IN_METERS
  },
  clusterLocation: null,
  establishmentListLocation: {
    type: 'address',
    address: DEFAULT_ADDRESS
  }
}

const FiltersContext = createContext<FiltersState>(defaultFilters)

export { FiltersContext }
